import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import ChallengeRanking from './ChallengeRanking'
import { getUserGoal, getUserProgress } from '../Activity/store/ActivitySelectors'
import { getCurrentCompanyGoal } from '../Activity/store/ActivityActions'

const mapStateToProps = (state: IGlobalState, ownProps: any) => {
  const goalId = ownProps.match.params.goalId
  return {
    goal: getUserGoal(state, goalId),
    userProgress: getUserProgress(state, goalId),
  }
}

const mapDispatchToProps = {
  getCurrentCompanyGoal,
}

export default connect(mapStateToProps, mapDispatchToProps)(ChallengeRanking)
